import {
  OvlAddScreen,
  OvlAddComponent,
} from "../../../../../../_ovlclient/src/global/globals"
import { NewServiceFormFooter } from "../../parts/formfooter"
import { NewServiceFormHeader } from "../../parts/formheader"
import { NewServiceStep1 } from "./newservicestep1/newservicestep1"
import { NewServiceStep2 } from "./newservicestep2/newservicestep2"
import { NewServiceStep3 } from "./newservicestep3/newservicestep3"

export const SVLNewService_Init = () => {
  OvlAddScreen(NewServiceStep1, "SVLNewServiceStep1")
  OvlAddScreen(NewServiceStep2, "SVLNewServiceStep2")
  OvlAddScreen(NewServiceStep3, "SVLNewServiceStep3")
  OvlAddComponent("itf-newserviceheader", NewServiceFormHeader)
  OvlAddComponent("itf-newservicefooter", NewServiceFormFooter)
}
